import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { ProductDetailsManagementSlice } from '../../../redux/features/BookingManagementSlice'

const OrderActiveConfirmDetails = () => {
  const {id} = useParams()
  const [iState,setUpdate] = useState([]);
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(ProductDetailsManagementSlice(id))?.then((res)=>{
      setUpdate(res?.payload?.data)
    })
  },[id]);

  return (
    <>
     <>
  <>
    <>
      <div className="OrderDetails">
        <h5>Booking Details</h5>
        <article>
          <aside>
            <p>
              <label>Booking Number</label>
              <span>{iState?.orderId}</span>
            </p>
            <p>
              <label>Placed on</label>
              <span>{iState?.createdAt?.slice(0,10)}</span>
            </p>
            <p>
              <label>Placed for</label>
              <span>{iState?.placedon?.slice(0,10)}</span>
            </p>
            <p>
              <label>Slot</label>
              <span>{iState?.slot}</span>
            </p>
          </aside>
          <aside>
            <p>
              <label>Payment Status</label>
              <span>{iState?.paymentStatus}</span>
            </p>
            <p>
              <label>Total Amount</label>
              <span>Rs.{iState?.totalAmount}</span>
            </p>
          </aside>
        </article>
      </div>
      <div className="OrderDetails">
        <h5>Customer Details</h5>
        <article>
          <aside>
            <p>
              <label>Customer Id</label>
              <span>{iState?.userId}</span>
            </p>
            <p>
              <label>Customer Name</label>
              <span>{iState?.customerName}</span>
            </p>
          </aside>
          <aside>
            <p>
              <label>Customer Contact Details</label>
              <span>{iState?.customerPhone}</span>
            </p>
          </aside>
        </article>
      </div>
      <div className="OrderDetails">
        <h5>Item(s) List</h5>
        <article>
          {/* <figure>
          <img src={iState?.prodimages} />
          </figure> */}
          <aside>
            <p>
              <label>Name of the product</label>
              <span>{iState?.productName}</span>
            </p>
          </aside>
          <aside>
            <p>
              <label>Qty</label>
              <span>{iState?.itemQuantity}</span>
            </p>
          </aside>
        </article>
      </div>
      <div className="OrderDetails">
        <h5>Venue Address</h5>
        <article>
          <aside>
            <p>
              <label>Full Name</label>
              <span>{iState?.customerName}</span>
            </p>
            <p>
              <label>Mobile Number </label>
              <span className='w-75 d-inline'>+91 {iState?.customerPhone}</span>
            </p>
            <p>
              <label>Address</label>
              <div>
                <p style={{width:'400px'}}>
                House Number/Flat No./Office No. : {iState?.deliveryAddress?.houseNo}
                </p>
                <p style={{width:'400px'}}>
                Road name, Area Name, Society Name : {iState?.deliveryAddress?.landmark},{iState?.deliveryAddress?.street}
                </p>
                <p style={{width:'400px'}}>
                City, Region, Country : {iState?.deliveryAddress?.city}
                </p>
                <p style={{width:'400px'}}>
                Pin Code : {iState?.deliveryAddress?.pincode} 
                </p>
              </div>
            </p>
          </aside>
        </article>
      </div>
      <div className="OrderDetails">
        <h5>Price Details</h5>
        <article>
          <aside>
            <p>
              <label>Total Amount</label>
              <span>Rs. {iState?.totalAmount}</span>
            </p>
            <p>
              <label>GST</label>
              <span>18%</span>
            </p>
            <p>
              {/* <label>Decorator Charges</label>
                      <span>Rs. 10.00</span> */}
            </p>
            <hr />
            <p>
              <label>You Pay</label>
              <span>Rs. {iState?.totalAmount}</span>
            </p>
          </aside>
        </article>
      </div>
      <div className="OrderDetails">
        <h5>Questions</h5>
        <article>
          <aside>
            <p style={{width:'100%'}}>
              <label>Where do you want us to do the decoration?* (Max 1)</label>
              <span>{iState?.decorationLocation}</span>
            </p>
            <p>
              <label>How did you come to know about Skyrixe?</label>
              <span>{iState?.aboutX}</span>
            </p>
            <p>
              <label>What is the occasion?</label>
              <span>{iState?.occasion}</span>
            </p>
            <p>
              <label>Select Ballons color(Max 3)</label>
              <span>{iState?.ballonsName?.map((item)=>(
               <div>
                {
                  item.name
                }
               </div>
              ))}</span>
            </p>
            <p>
              <label>Additional Phone Number</label>
              <span>{iState?.altContact}</span>
            </p>
            <p>
              <label>Mention the age or anniversary year for foil balloons? (Max 2)</label>
              <span>{iState?.ageColour}</span>
            </p>
            <p>
              <label>Select the color of the age balloon or foil balloon?</label>
              <span>{iState?.customerage}</span>
            </p>
            
            <p>
              <label>Customer Requirement</label>
              <span>{iState?.customerRequirement}</span>
            </p> 
            
          </aside>
        </article>
      </div>
   
      <div className="OrderDetails">
        <h5>Product details</h5>
        <article>
          <aside>
            <p style={{width:'100%'}}>
              <label>Product Name</label>
              <span>{iState?.productName}</span>
            </p>              
            <p style={{width:'100%'}}>
              <label>Product image</label>
              <div className='h-25 w-25'><img className='h-100 w-100' src={iState?.prodimages?.[0]} alt="" /></div>
            </p>              
             {iState?.productcustomizeDetails?.length > 0 && <p
                className=" ProfileBox2"
                style={{ display: "flex", flexDirection: "column" }}
              >
                              <label>Product Customization Details</label>
                {iState?.productcustomizeDetails?.map((item, key) => {
                  
                  return (
                    <div
                      style={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        marginBottom: "20px",
                        border: "1px solid lightgray",
                        padding: "10px",
                        borderRadius: "10px",
                        position: "relative",
                      }}
                    >
                    <div key={key} style={{ display: "flex", gap: "10px" }}>
                        <div>
                          <p
                            style={{
                              textTransform: "capitalize",
                              color: "#000",
                              fontSize: "14px",
                              fontWeight: "700",
                            }}
                          >
                            Product Name
                          </p>
                          <input
                            type="text"
                            class="form-control"
                            disabled={true}
                            value={item["name"]}
                            name="name"
                          />
                        </div>
                        <div>
                          <p
                            style={{
                              textTransform: "capitalize",
                              color: "#000",
                              fontSize: "14px",
                              fontWeight: "700",
                            }}
                          >
                            Product Price
                          </p>
                          <input
                            type="text"
                            class="form-control"
                            disabled={true}
                            value={item["price"]}
                            name="ProductPrice"
                          />
                        </div>
                        <div>
                          <p
                            style={{
                              textTransform: "capitalize",
                              color: "#000",
                              fontSize: "14px",
                              fontWeight: "700",
                            }}
                          >
                            Product Image
                          </p>
                          <div
                            style={{
                              position: "relative",
                              width: "100px",
                              height: "60px",
                              border: "2px dotted grey",
                              backgroundColor: "#6e60601c",
                            }}
                          >
                            <div>
                              <img
                                src={item["customimages"]}
                                style={{
                                  height: "60px",
                                  width: "100px",
                                }}
                                alt="Loading from Bucket"
                                srcset=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </p>}           
          </aside> 
        </article>
      </div>
    </>
  </>
  <div className="ModalBox">
    <div
      id="LogOutModal"
      className="modal fade"
      style={{ display: "none" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <div className="Decline">
              <a
                href="javascript:void(0);"
                className="CloseModal"
                data-dismiss="modal"
              >
                ×
              </a>
              <h3>Log Out</h3>
              <p>Are you sure you want to logout?</p>
              <h4>
                <a href="javascript:void(0);" data-dismiss="modal">
                  no
                </a>
                <a href="login.html">Yes</a>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
 
    </>
  )
}

export default OrderActiveConfirmDetails
